import type {PropsWithChildren} from 'react'
import {clsx} from 'clsx'
import styles from './List.module.css'

interface ListProps {
  className?: string
}

export default function List({children, className}: PropsWithChildren<ListProps>) {
  return (
    <div data-testid="results-list" className={clsx(styles.List, className)}>
      {children}
    </div>
  )
}
